var React = require('react');

function LogoEN (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",null,[React.createElement("path",{"fill":"currentColor","d":"M24.944 21.35H9.801v7.13h8.006v14.209H7.129v-7.081H0v1.736c0 6.89 5.589 12.477 12.48 12.474 6.888-.003 12.47-5.59 12.47-12.48l-.006-15.988zM89.109 21.35H78.433v-3.74H89.11v3.74zM78.433 10.482h3.35v-3.35h-3.35v3.35zm10.295.122c.122-.58.184-1.183.184-1.799C88.912 3.942 84.97 0 80.107 0h-8.802v28.476h15.943c4.97 0 8.998-4.028 8.998-8.998 0-4.463-3.252-8.167-7.518-8.874z","transform":"translate(-58 -23) translate(58 23)","key":0}),React.createElement("path",{"fill":"#0FF","d":"M30.298 28.479L65.957 28.479 65.957 21.35 30.298 21.35z","transform":"translate(-58 -23) translate(58 23)","key":1})]))));
}

LogoEN.defaultProps = {"width":"97","height":"50","viewBox":"0 0 97 50"};

module.exports = LogoEN;

LogoEN.default = LogoEN;
